/** @format */

import React, { Component } from 'react';
import { Form, Button, Icon, Header } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';
import { debounce } from 'lodash';
import { database } from 'firebase';
import surnames from '../../../helpers/surnames';
import formatNames from '../../../helpers/formatNames';

let checkSurnamesTimeout;

@inject('ClientsStore')
@observer
class ClientQuickCreate extends Component {
  state = {
    invertedNames: false,
    mobilePhone: {
      error: null,
      loading: false,
    },
  };

  renderInvertedNameError = () => {
    if (this.state.invertedNames) {
      return (
        <Header as="h5" color="red">
          Sembra che abbia scritto un cognome nel campo del nome, controlla
          prima di salvare il cliente. Se il cliente fornisce solo il cognome
          usa una x al posto del nome.
        </Header>
      );
    } else {
      return null;
    }
  };

  debouncedDuplicatePhoneCheck = debounce(phone => {
    this.setState({
      mobilePhone: {
        error: null,
        loading: true,
      },
    });

    database()
      .ref('clients')
      .orderByChild('data/mobPhone')
      .startAt('')
      .once('value', snap => {
        const values = snap.val() || [];

        for (const key in values) {
          const { data } = values[key];

          if (data && data.mobPhone === phone) {
            return this.setState({
              mobilePhone: {
                error: intl.get('clients.cellphone_duplicate'),
                loading: false,
              },
            });
          }
        }

        return this.setState({
          mobilePhone: {
            error: null,
            loading: false,
          },
        });
      });
  }, 2000);

  checkSurnames = value => {
    let $this = this;
    if (typeof checkSurnamesTimeout !== 'undefined') {
      clearTimeout(checkSurnamesTimeout);
    }
    checkSurnamesTimeout = setTimeout(() => {
      if (surnames.includes(value.toLowerCase())) {
        $this.setState({ invertedNames: true });
      } else {
        $this.setState({ invertedNames: false });
      }
    }, 500);
  };

  onMobileChange = e => {
    const { ClientsStore } = this.props;

    const { value, name } = e.target;

    ClientsStore.handleClientInput(name, value);

    this.setState({
      mobilePhone: {
        error: null,
        loading: false,
      },
    });

    this.debouncedDuplicatePhoneCheck.cancel();

    if (value.trim().length > 5) {
      return this.debouncedDuplicatePhoneCheck(value);
    }
  };

  render() {
    const { ClientsStore } = this.props;

    return (
      <Form size="small" onSubmit={() => ClientsStore.handleClientSubmit()}>
        <Form.Group widths="equal">
          <Form.Input
            autoComplete="off"
            onInput={e => {
              ClientsStore.handleClientInput(
                e.target.name,
                formatNames(e.target.value),
              );
              this.checkSurnames(e.target.value);
            }}
            fluid
            name="name"
            label="Nome o Ragione Sociale"
            placeholder="First name"
            value={ClientsStore.currentClient.data.name}
            required
          />
          <Form.Input
            autoComplete="off"
            onInput={e =>
              ClientsStore.handleClientInput(
                e.target.name,
                formatNames(e.target.value),
              )
            }
            fluid
            name="surname"
            label="Cognome"
            placeholder="Last name"
            value={ClientsStore.currentClient.data.surname}
            required
          />
          <Form.Input
            autoComplete="off"
            onInput={this.onMobileChange}
            fluid
            name="mobPhone"
            label="Cellulare"
            placeholder="Cellulare"
            value={ClientsStore.currentClient.data.mobPhone}
            loading={this.state.mobilePhone.loading}
            required
            error={this.state.mobilePhone.error}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            autoComplete="off"
            onInput={e =>
              ClientsStore.handleClientInput(
                e.target.name,
                formatNames(e.target.value),
              )
            }
            fluid
            name="plate"
            label="Targa"
            placeholder="Targa"
            value={ClientsStore.currentClient.data.plate}
            required
          />
          <Form.Select
            autoComplete="off"
            required
            name="type"
            placeholder="Tipologia Cliente"
            value={ClientsStore.currentClient.data.type}
            onChange={(e, result) =>
              ClientsStore.handleClientInput(result.name, result.value)
            }
            label="Tipologia"
            options={[
              { text: 'privato', value: 'privato' },
              { text: 'azienda', value: 'azienda' },
            ]}
            fluid
          />
        </Form.Group>
        {this.renderInvertedNameError()}
        <Button type="submit" size="small" color="green" fluid>
          <Icon name="plus" /> Nuovo Cliente
        </Button>
      </Form>
    );
  }
}

export default ClientQuickCreate;
